import React from 'react';
import { CalendarMonth, AttachMoney, AccountBalanceWallet, MenuBook, OpenInNew, Logout } from '@mui/icons-material';

const Sidebar = ({ page, setPage, onLogout, currentUser, onOpenWiki }) => {
    const items = [
        { key: 'calendar',  icon: <CalendarMonth />,          label: 'Календар' },
        { key: 'salary',    icon: <AttachMoney />,             label: 'Зарплата' },
        ...(currentUser?.is_admin ? [
            { key: 'expenses', icon: <AccountBalanceWallet />, label: 'Витрати' },
            // ВікіStats відкривається окремою сторінкою (#/wiki) зі своїм дизайном
            { key: 'wiki', icon: <MenuBook />, label: 'ВікіStats', onClick: onOpenWiki, external: true },
        ] : []),
    ];

    return (
        <aside style={{
            width: 220,
            background: '#1a1a1a',
            borderRight: '1px solid #2e2e2e',
            display: 'flex',
            flexDirection: 'column',
            padding: '24px 12px',
            gap: 4,
            minHeight: '100vh',
        }}>
            <div style={{ color: '#cf85e8', fontWeight: 700, fontSize: 16, marginBottom: 24, paddingLeft: 12 }}>
                My Calendar
            </div>

            {items.map(item => (
                <button
                    key={item.key}
                    onClick={() => (item.onClick ? item.onClick() : setPage(item.key))}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 10,
                        padding: '10px 12px',
                        borderRadius: 8,
                        border: 'none',
                        cursor: 'pointer',
                        background: page === item.key ? '#5865f2' : 'transparent',
                        color: page === item.key ? '#fff' : '#888',
                        fontWeight: page === item.key ? 600 : 400,
                        fontSize: 14,
                        transition: 'all 0.15s',
                        width: '100%',
                        textAlign: 'left',
                    }}
                    onMouseEnter={e => { if (page !== item.key) e.currentTarget.style.background = '#242424'; }}
                    onMouseLeave={e => { if (page !== item.key) e.currentTarget.style.background = 'transparent'; }}
                >
                    {item.icon}
                    {item.label}
                    {item.external && <OpenInNew style={{ fontSize: 14, marginLeft: 'auto', opacity: 0.6 }} />}
                </button>
            ))}

            <div style={{ flex: 1 }} />

            {currentUser && (
                <div style={{ padding: '8px 12px', marginBottom: 4, borderRadius: 8, background: '#242424', border: '1px solid #2e2e2e' }}>
                    <div style={{ color: '#555', fontSize: 10, textTransform: 'uppercase', letterSpacing: 0.8 }}>Акаунт</div>
                    <div style={{ color: '#e8e8e8', fontSize: 13, fontWeight: 600, marginTop: 2 }}>{currentUser.login}</div>
                </div>
            )}

            <button
                onClick={onLogout}
                style={{
                    display: 'flex', alignItems: 'center', gap: 10,
                    padding: '10px 12px', borderRadius: 8, border: 'none',
                    cursor: 'pointer', background: 'transparent',
                    color: '#888', fontSize: 14, width: '100%', textAlign: 'left',
                }}
                onMouseEnter={e => { e.currentTarget.style.background = '#2e2e2e'; e.currentTarget.style.color = '#e8e8e8'; }}
                onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = '#888'; }}
            >
                <Logout fontSize="small" />
                Вийти
            </button>
        </aside>
    );
};

export default Sidebar;
